import React, { Component } from 'react';

class Search extends Component {
    state = {
        query: '',
        transactionType: '',
        startDate: '',
        endDate: '',
        minAmount: '',
        maxAmount: '',
        results: [],
        loading: false,
        error: null,
        hasSearched: false
    };

    handleInputChange = (e) => {
        this.setState({ [e.target.name]: e.target.value });
    };

    handleSearch = async (e) => {
        e.preventDefault();
        
        this.setState({ loading: true, error: null });
        
        try {
            const { query, transactionType, startDate, endDate, minAmount, maxAmount } = this.state;
            
            // Build query string
            const params = new URLSearchParams();
            if (query) params.append('q', query);
            if (transactionType) params.append('type', transactionType);
            if (startDate) params.append('start_date', startDate);
            if (endDate) params.append('end_date', endDate);
            if (minAmount) params.append('min_amount', minAmount);
            if (maxAmount) params.append('max_amount', maxAmount);
            
            const url = `${process.env.REACT_APP_API_URL}/api/account/search?${params.toString()}`;
            
            const response = await fetch(url, {
                method: 'GET',
                credentials: 'include',
                mode: 'cors',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'Cache': 'no-cache'
                }
            });
            
            const result = await response.json();
            
            if (result.msg === 'Search results') {
                this.setState({ 
                    results: result.results,
                    loading: false,
                    hasSearched: true
                });
            } else {
                this.setState({ 
                    error: 'Search failed',
                    loading: false,
                    hasSearched: true
                });
            }
        } catch (error) {
            this.setState({ 
                error: 'Error performing search',
                loading: false,
                hasSearched: true
            });
        }
    };

    handleClear = () => {
        this.setState({
            query: '',
            transactionType: '',
            startDate: '',
            endDate: '',
            minAmount: '',
            maxAmount: '',
            results: [],
            error: null,
            hasSearched: false
        });
    };

    render() {
        const { 
            query, 
            transactionType, 
            startDate, 
            endDate, 
            minAmount,
            maxAmount,
            results, 
            loading, 
            error,
            hasSearched 
        } = this.state;

        return (
            <section className="search-transactions">
                <h2>Search Transactions</h2>
                
                <form onSubmit={this.handleSearch} className="search-form">
                    <div className="search-row">
                        <div className="form-group">
                            <label htmlFor="query">Search Term</label>
                            <input
                                type="text"
                                id="query"
                                name="query"
                                value={query}
                                onChange={this.handleInputChange}
                                placeholder="Search by description..."
                                className="form-control"
                            />
                        </div>
                        
                        <div className="form-group">
                            <label htmlFor="transactionType">Type</label>
                            <select
                                id="transactionType"
                                name="transactionType"
                                value={transactionType}
                                onChange={this.handleInputChange}
                                className="form-control"
                            >
                                <option value="">All Types</option>
                                <option value="Credit">Credit</option>
                                <option value="Debit">Debit</option>
                            </select>
                        </div>
                    </div>
                    
                    <div className="search-row">
                        <div className="form-group">
                            <label htmlFor="startDate">Start Date</label>
                            <input
                                type="date"
                                id="startDate"
                                name="startDate"
                                value={startDate}
                                onChange={this.handleInputChange}
                                className="form-control"
                            />
                        </div>
                        
                        <div className="form-group">
                            <label htmlFor="endDate">End Date</label>
                            <input
                                type="date"
                                id="endDate"
                                name="endDate"
                                value={endDate}
                                onChange={this.handleInputChange}
                                className="form-control"
                            />
                        </div>
                    </div>
                    
                    <div className="search-row">
                        <div className="form-group">
                            <label htmlFor="minAmount">Min Amount</label>
                            <input
                                type="number"
                                id="minAmount"
                                name="minAmount"
                                value={minAmount}
                                onChange={this.handleInputChange}
                                placeholder="0.00"
                                min="0"
                                step="0.01"
                                className="form-control"
                            />
                        </div>
                        
                        <div className="form-group">
                            <label htmlFor="maxAmount">Max Amount</label>
                            <input
                                type="number"
                                id="maxAmount"
                                name="maxAmount"
                                value={maxAmount}
                                onChange={this.handleInputChange}
                                placeholder="0.00"
                                min="0"
                                step="0.01"
                                className="form-control"
                            />
                        </div>
                    </div>
                    
                    <div className="search-actions">
                        <button 
                            type="submit" 
                            className="btn btn-primary"
                            disabled={loading}
                        >
                            {loading ? 'Searching...' : 'Search'}
                        </button>
                        <button 
                            type="button" 
                            className="btn btn-secondary"
                            onClick={this.handleClear}
                        >
                            Clear
                        </button>
                    </div>
                </form>
                
                {error && (
                    <div className="error-message">{error}</div>
                )}
                
                {hasSearched && (
                    <div className="search-results">
                        <h3>Results ({results.length})</h3>
                        
                        {results.length === 0 ? (
                            <p className="no-results">No transactions found matching your criteria.</p>
                        ) : (
                            <table className="table">
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Type</th>
                                        <th>Description</th>
                                        <th>Amount</th>
                                        <th>Date</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {results.map((trans, index) => (
                                        <tr key={trans.id}>
                                            <td>{index + 1}</td>
                                            <td className={trans.type === 'Credit' ? 'positive' : 'negative'}>
                                                {trans.type}
                                            </td>
                                            <td dangerouslySetInnerHTML={{ __html: trans.description }}></td>
                                            <td className={trans.type === 'Credit' ? 'positive' : 'negative'}>
                                                {trans.amount}
                                            </td>
                                            <td>{trans.time}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        )}
                    </div>
                )}
            </section>
        );
    }
}

export default Search;

